import { useState, useEffect, useMemo } from 'react';

const usePagination = (data = [], itemsPerPage = 10) => {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = useMemo(() => Math.ceil(data.length / itemsPerPage), [data.length, itemsPerPage]);

    // Ensure currentPage is always within bounds
    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1); // fallback to 1 if totalPages is 0
        }
    }, [totalPages, currentPage]);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return data.slice(start, start + itemsPerPage);
    }, [data, currentPage, itemsPerPage]);

    return {
        currentPage,
        setCurrentPage,
        totalPages,
        paginatedData,
    };
};

export default usePagination;
